import { VersionInfo } from "../VersionInfo";

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="mt-6 border-t border-white/10 bg-[#1A1A1A] py-6">
      <div className="mx-auto flex max-w-[1136px] flex-col items-center justify-between gap-3 px-4 sm:flex-row">
        <span className="text-sm text-white/60 text-center sm:text-left">
          © {new Date().getFullYear()} Todos os direitos reservados —{" "}
          <span className="text-white font-medium">LikeAPPro</span>
        </span>

        <VersionInfo />

        <button
          onClick={scrollToTop}
          className="group flex items-center gap-2 text-sm text-white/60 transition-colors hover:text-white"
        >
          Voltar para o início
          <svg
            width="18"
            height="18"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="opacity-60 transition-transform group-hover:-translate-y-1"
          >
            <path
              d="M10 15.8337V4.16699M10 4.16699L4.16667 10.0003M10 4.16699L15.8333 10.0003"
              stroke="currentColor"
              strokeWidth="1.67"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </footer>
  );
};
